module.exports = __webpack_public_path__ + "img/linkedin.8d317898.svg";